module.exports = __webpack_public_path__ + "static/27-AN-HR-EXPERTS-REACTION-TO-THE-NEW-UK-FLEXIBLE-WORKING-BILL-a14c24762ecdb00ceb4da74023d7ad68.jpg";